import { render, staticRenderFns } from "./UploadSendMessage.vue?vue&type=template&id=2375fb4c&"
import script from "./UploadSendMessage.vue?vue&type=script&lang=js&"
export * from "./UploadSendMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports